import { LABEL } from "../voices/types";

export enum RateSpeechActions {
  LIKE = "Like",
  DISLIKE = "Dislike",
  FAVORITE = "Favorite",
  CONFIRM = "Confirm",
}

export type ChatModalRateSpeechProps = {
  listItems?: ListItems[];
  onOpenChange?: (isOpen: boolean) => void;
  open?: boolean;
  voiceRateLoading?: boolean;
  actionHandler: (action: RateSpeechActions, feedback?: LABEL) => Promise<void> | undefined;
  isMobile?: boolean;
  isChatRateMobile?: boolean;
  iconColor?: string;
};

export type ListItems = {
  label: string;
  subLabel: LABEL;
};
